import React from "react";
import Navbar from "../components/navbar/desktop";
import HeroSlider from "../components/heroSlider";
import MasonrySection from "../sections/masonry";
import MainNewsLetter from "../components/newsletter/main";
import ReviewsSection from "../sections/reviews";
import SecondaryNewsLetter from "../components/newsletter/main/secondary";
import CelebStories from "../sections/celebStories";
import JustInSection from "../sections/justin";
import Footer from "../components/footer/desktop";
import { graphql } from "gatsby";
import Seo from "../components/seoHead";

const IndexPage = ({ data }) => {
  const [scrollActive, setScrollActive] = React.useState(false);

  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      // Remove the event listener when the component is unmount.
      window.removeEventListener("scroll", handleScroll);
    };
  });

  const handleScroll = () => {
    if (window.scrollY > 30) {
      setScrollActive(true);
    } else {
      setScrollActive(false);
    }
  };

  let sliderData = data?.vglwpgraphql?.posts?.edges.slice(0, 3);
  let masonryGridData = data?.vglwpgraphql?.posts?.edges.slice(3, 7);
  let justInSectionData = data?.vglwpgraphql?.posts?.edges.slice(7, 17);
  let reviewsPosts = data?.reviews?.posts?.edges;

  return (
    <>
      <Seo
        data={data?.seoData?.page?.seo}
        link={data?.seoData?.page?.link}
      />
      <Navbar />
      <main
        style={{
          backgroundColor: "rgb(255,228,183)",
        }}
      >
        <div
          className={`vgl-hero-slider vgl-slider-container ${
            scrollActive && "scrolled"
          }`}
        >
          <div
            className="vgl-slider-item-border-bottom"
            style={{ background: "rgb(95, 100, 97)" }}
          ></div>
          <HeroSlider data={sliderData} />
        </div>
        {/* <div style={{ paddingTop: 100 }}> */}
        <MasonrySection data={masonryGridData} />
        <MainNewsLetter />
        <ReviewsSection data={reviewsPosts} />
        <CelebStories data={data?.celebs?.posts?.edges} />
        <JustInSection data={justInSectionData} />
        <SecondaryNewsLetter />
        <Footer bg={"#f8b195"} />
        {/* </div> */}
      </main>
    </>
  );
};

export default IndexPage;

export const pageQuery = graphql`
  query {
    seoData: vglwpgraphql {
      page(id: "14141", idType: DATABASE_ID) {
        seo {
          canonical
          metaDesc
          title
          schema {
            raw
          }
          twitterDescription
          twitterTitle
          twitterImage {
            mediaItemUrl
          }
          opengraphUrl
          opengraphType
          opengraphTitle
          opengraphPublishedTime
          opengraphModifiedTime
          opengraphImage {
            mediaItemUrl
          }
          metaRobotsNoindex
          metaRobotsNofollow
          metaKeywords
          opengraphDescription
        }
        link
      }
    }
    vglwpgraphql {
      posts(
        where: { orderby: { field: DATE, order: DESC }, status: PUBLISH }
        first: 17
      ) {
        edges {
          node {
            categories {
              nodes {
                slug
                name
                databaseId
              }
            }
            featuredImage {
              node {
                link
                mediaItemUrl
                slug
                sourceUrl
              }
            }
            excerpt
            date
            slug
            title
            databaseId
            status
            uri
            author {
              node {
                name
              }
            }
          }
        }
      }
    }
    reviews: vglwpgraphql {
      posts(
        where: {
          tag: "reviews"
          orderby: { field: DATE, order: DESC }
          status: PUBLISH
        }
        first: 10
      ) {
        edges {
          node {
            categories {
              nodes {
                slug
                name
                databaseId
              }
            }
            featuredImage {
              node {
                link
                mediaItemUrl
                slug
                sourceUrl
              }
            }
            excerpt
            date
            slug
            title
            databaseId
            status
            uri
            author {
              node {
                name
              }
            }
          }
        }
      }
    }
    celebs: vglwpgraphql {
      posts(
        where: {
          tag: "celebrities"
          orderby: { field: DATE, order: DESC }
          status: PUBLISH
        }
        first: 5
      ) {
        edges {
          node {
            featuredImage {
              node {
                mediaItemUrl
              }
            }
            excerpt
            date
            slug
            title
            databaseId
            status
            uri
            blogPost {
              celebrity
            }
          }
        }
      }
    }
  }
`;
